import { accessDBApi } from './api';
import type { ApiResponse, Pagination, ChatSession } from '../types';

export interface ChatLogsListResponse {
  sessions: ChatSession[];
  pagination: Pagination;
}

export interface ChatLogsParams {
  page?: number;
  limit?: number;
  from?: string;
  to?: string;
  session_id?: string;
}

export const chatLogService = {
  // チャット履歴一覧取得
  getChatLogs: async (
    domainId: string,
    params?: ChatLogsParams
  ): Promise<ApiResponse<ChatLogsListResponse>> => {
    const response = await accessDBApi.get(`/v1/domains/${domainId}/chat-logs`, { params });
    return response.data;
  },

  // チャット履歴エクスポート（CSV or JSON）
  exportChatLogs: async (domainId: string, from: string, to: string, format: 'csv' | 'json' = 'csv', columns?: string[]): Promise<Blob> => {
    const params: Record<string, string> = { from, to };
    if (format === 'json') params.format = 'json';
    if (columns && columns.length > 0 && format !== 'json') params.columns = columns.join(',');
    const response = await accessDBApi.get(`/v1/domains/${domainId}/chat-logs/export`, {
      params,
      responseType: 'blob',
    });
    return response.data;
  },

  // ダウンロード（CSV or JSON）
  downloadChatLogs: async (domainId: string, from: string, to: string, domain: string, format: 'csv' | 'json' = 'csv', columns?: string[]): Promise<void> => {
    const blob = await chatLogService.exportChatLogs(domainId, from, to, format, columns);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    // eslint-disable-next-line no-restricted-syntax
    link.href = url;
    link.download = `chat_logs_${domain}_${from}_${to}.${format === 'json' ? 'json' : 'csv'}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },
};
